import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ImageSm from './assets/hero-image-sm.png'
import Image from './assets/hero-image.png'
import Image2x from './assets/hero-image@2x.png'
import { CREATE_ACCOUNT, VIEW_EXCHANGE_PATH } from '../../constants/routes'
import DataProvider from '../../utils/provider'
import { getTextByLang } from '../ExternalFields'
import { useStore } from '../../StateProvider'
import formStyles from '../../ui/Form/style.css'
import styles from './style.css'

export const Intro = () => {
  const { t } = useTranslation()
  const [showDemoModeError, setShowDemoModeError] = useState('')
  const [
    {
      whitelabel: { showDemoButton, targetPlatform, customTexts }
    }
  ] = useStore()

  const openDemoMode = () => {
    /**
     * @param {{demoURL: string}} params
     */
    const resolve = ({ demoURL }) => {
      window.location = demoURL
    }
    const reject = () => setShowDemoModeError(t('intro.demoViewError'))

    DataProvider.get(`${VIEW_EXCHANGE_PATH}`).then(resolve, reject)
  }

  return (
    <div className={styles.intro}>
      <div className={styles.content}>
        <div className={styles.text}>
          <h1 className={styles.textHeading}>
            {getTextByLang('introHeader', customTexts, t('intro.title'))}
          </h1>
          <p className={styles.textCaption}>
            {getTextByLang('introDescription', customTexts, t('intro.text'))}
          </p>
        </div>
        <div className={styles.actions}>
          <Link to={CREATE_ACCOUNT} className={`${formStyles.action} ${styles.createAccount}`}>
            {t('intro.createAccount')}
          </Link>
          {showDemoButton && (
            <button
              className={`${formStyles.action} ${styles.viewExchange}`}
              onClick={openDemoMode}
            >
              {t(`intro.${targetPlatform}ViewDemo`)}
            </button>
          )}
        </div>
        <div>{showDemoModeError}</div>
      </div>
      <picture className={styles.imageContainer}>
        <source media='(max-width: 44.9375em)' srcSet={ImageSm} />
        <source media='(min-width: 45.0000em)' srcSet={`${Image} 1x, ${Image2x} 2x`} />
        <img className={styles.introImage} src={Image} alt='introImage' />
      </picture>
    </div>
  )
}
